export default "__VITE_ASSET__Cxqvv88q__"